<template>
  <div class="form">
    <h1 class="extra-large-headline">{{ $t("PlaidRedirectView.heading.continue") }}</h1>
    <p>{{ $t("PlaidRedirectView.paragraph.instruction") }}</p>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import useApiHelpers from '@/composables/api/helpers';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import useReviveLocalStorage from '@/composables/storage/useReviveLocalStorage';
import useErrorHandling from '@/composables/api/useErrorHandling';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const router = useRouter();
const orderStore = useOrderFormStore();
const { postRequest } = useApiHelpers();
const { t } = useI18n();
const { reviveLocalStorage } = useReviveLocalStorage();
const { handleErrorInSpaFlow } = useErrorHandling();

const oAuthStateId = ref(null);
const linkCorrelationId = ref(null);

const redirectToPaymentPage = () => {
  const pspCode = orderStore.getPaymentProvider?.code;

  if (!pspCode) {
    handleErrorInSpaFlow(4015, t('Dlocal.error.4015'));
    return;
  }

  router.push({
    path: `/payment/${pspCode}`,
    query: {
      oauth_state_id: oAuthStateId.value,
      link_correlation_id: linkCorrelationId.value,
    },
  });
};

const savePlaidLinkTokenToLocalStorage = (plaidLinkToken) => {
  if (plaidLinkToken) {
    localStorage.setItem('plaidLinkToken', JSON.stringify(plaidLinkToken));
  }
};

const getUsedPlaidLinkToken = async () => postRequest(
      '/plaid/getUsedLinkToken',
      {
        linkCorrelationId: linkCorrelationId.value,
      },
    );

onMounted(async () => {
  oAuthStateId.value = route.query.oauth_state_id;
  linkCorrelationId.value = route.query.link_correlation_id;

  try {
    const plaidData = await getUsedPlaidLinkToken();
    savePlaidLinkTokenToLocalStorage(plaidData?.data?.plaidLinkToken);
    await reviveLocalStorage(plaidData?.data?.orderKey);
    redirectToPaymentPage();
  } catch (error) {
    const failedData = error?.response?.data;
    // NOTOE: Redirect for 100008 error code
    handleErrorInSpaFlow(
      failedData?.code || 4015,
      failedData?.message || '',
    );
  }
});
</script>
